import { useState } from "react";
import { useDispatch } from "react-redux";
import { IconButton, Box, Typography, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { shades } from "../theme";
import { addToCart } from "../state";
import { useNavigate } from "react-router-dom";
import CustomButton from "./CustomButton";
import { API_URL } from "../apis/api";

// Base URL for Vercel Blob storage
const BLOB_BASE_URL = "https://eezvqt4vd5kslelz.public.blob.vercel-storage.com";

const Item = ({ item, width, small, style }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [count, setCount] = useState(1);
  const [isHovered, setIsHovered] = useState(false);
  const {
    palette: { neutral },
  } = useTheme();

  // Debug: Log the item structure to see the correct ID field
  console.log("Item structure:", item);

  const { Name, price, category, image } = item;

  // Use the correct ID - Strapi items typically have id at the root level
  const itemId = item.id || item.attributes?.id;

  let imageUrl = image?.formats?.medium?.url || image?.url || "";
  // Only prepend API_URL if the image is not a local fallback image or Vercel Blob URL
  if (imageUrl && imageUrl.startsWith("/items/")) {
    // Use as-is for fallback images
  } else if (imageUrl && imageUrl.startsWith(BLOB_BASE_URL)) {
    // Use as-is for Vercel Blob URLs
  } else if (imageUrl && imageUrl.startsWith("/")) {
    imageUrl = `${API_URL}${imageUrl}`;
  }

  return (
    <Box
      width={width || 300}
      height={400}
      sx={{
        background: "transparent",
        boxShadow: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 0,
        p: 0,
        m: "auto",
      }}
    >
      <Box
        position="relative"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        sx={{
          "@media (max-width:600px)": {
            alignItems: "stretch",
            width: "100%",
          },
        }}
        height={300}
      >
        <img
          alt={Name}
          src={imageUrl}
          onClick={() => {
            console.log("Navigating to item with ID:", itemId);
            navigate(`/item/${itemId}`);
          }}
          style={{
            cursor: "pointer",
            maxWidth: "100%",
            maxHeight: "100%",
            width: "100%",
            height: "auto",
            objectFit: "contain",
            display: "block",
            margin: 0,
            ...(style || {}),
          }}
        />
        <Box
          display={isHovered && !small ? "block" : "none"}
          position="absolute"
          bottom="10%"
          left="0"
          width="100%"
          padding="0 5%"
        >
          <Box display="flex" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              backgroundColor={shades.neutral[100]}
              borderRadius="3px"
            >
              <IconButton
                size={small ? "small" : "medium"}
                onClick={() => setCount(Math.max(count - 1, 1))}
              >
                <RemoveIcon fontSize={small ? "small" : "medium"} />
              </IconButton>
              <Typography
                color={shades.primary[300]}
                fontSize={small ? 12 : undefined}
              >
                {count}
              </Typography>
              <IconButton
                size={small ? "small" : "medium"}
                onClick={() => setCount(count + 1)}
              >
                <AddIcon fontSize={small ? "small" : "medium"} />
              </IconButton>
            </Box>
            <CustomButton
              onClick={() => {
                dispatch(addToCart({ item: { ...item, count } }));
              }}
              size={small ? "small" : "medium"}
            >
              Add to Cart
            </CustomButton>
          </Box>
        </Box>
      </Box>

      <Box mt="3px">
        <Typography
          variant="subtitle2"
          color={neutral?.dark}
          fontSize={small ? 10 : undefined}
        >
          {category
            ?.replace(/([A-Z])/g, " $1")
            ?.replace(/^./, (str) => str.toUpperCase())}
        </Typography>
        <Typography fontSize={small ? 12 : undefined}>{Name}</Typography>
        <Typography fontWeight="bold" fontSize={small ? 12 : undefined}>
          ${price}
        </Typography>
      </Box>
    </Box>
  );
};

export default Item;
